module.exports = __webpack_public_path__ + "assets/media/day17.cfb620bf.mp3";